import styled from 'styled-components';

export const Label = styled.label`
  font-size: 14px;
  color: ${(props) => props.theme.text.primary};
`;
